export const DEFAULT_CANVAS_SIZE = 1024;
export const DESIGN_SCALE = 0.688;

export function createInitialDesignerState() {
  return {
    tool: 'Polygon',
    designType: 'M',
    panelNotSet: false,
    designs: [],
    isLoadingDesigns: false,
    isCloningDesign: false,
    isRenamingDesign: false,
    isDeletingDesign: false,
    segments: [],
    obstacles: [],
    trees: [],
    panels: [],
    shade: false,
    buffered: [],
    package: {},
    hasAutoCalculatedInverterQuantity: false,
    buffer: 12.7,
    rowSpacing: 0,
    panelTilt: 0,
    azimuthRestriction: [0, 360],
    powerOptimizer: null,
    selectedRoof: -1,
    selectedLabel: 'Eave',
    selectedPanels: false,
    roofAreasSqFt: [],
    roofAreasUnit: 'ft²',
    roofAreasSignature: '',
    setbackMode: 0,
    fireSetbacks: {
      general: 18,
      eave: 0,
      ridge: 18,
      rake: 18,
      hip: 18,
      valley: 18
    },
    mode: 'select',
    moveMode: 'group',
    polyEdit: -1,
    focusedPolygonToEdit: -1,
    currentAccordion: 'segments',
    currentTab: null,
    scale: DESIGN_SCALE,
    canvasSize: DEFAULT_CANVAS_SIZE,
    showOverlay: false,
    colorRange: [0, 2450],
    isFullScreen: false,
    viewMode: '2D',
    selectionMode: 'segment',
    coordinates: [],
    selectedObjects: {
      roofSegments: [],
      roofVertices: {},
      roofLines: {},
      obstacles: [],
      fireSetbacks: {},
      panels: {},
      trees: []
    },
    optPitchAndAzimuth: { pitch: 24.0, azimuth: 184.0 },
    optPOA: null,
    shadingTexture: null,
    shadingMonth: 0,
    shadingStatus: 0,
    shadingIsRunning: false,
    serverSideShadingIsRunning: false,
    optimizer1IsRunning: false,
    optimizer2IsRunning: false,
    edgeDetectionIsRunning: false,
    rectificationIsRunning: false,
    measureIsRunning: false,
    panelPlacementIsRunning: false,
    AIIsRunning: false,
    treeAIIsRunning: false,
    useGoogleDSMForTreeAI: false,
    automaticAzimuth: false,
    pvwattsHandled: false,
    solarPanels: [],
    inverters: [],
    losses: null,
    updateRGBTextureIsRunning: false,
    panelPlacementFillMode: 3,
    panelPlacementLayoutMode: 2,
    panelPlacementOnlySelectedRoof: false,
    productionIsRunning: false,
    productionHandled: false,
    totalAnnualKwh: 0,
    totalMonthlyKwh: Array(12).fill(0),
    totalClippingKwh: 0,
    totalMonthlyClippingKwh: Array(12).fill(0),
    dcAcRatio: null,
    stringingData: null,
    invertersUsed: null,
    productionPerPanel: 0,
    productionPerPanelData: null,
    productionPerStringData: null,
    hourlyProduction: null,
    productionHardware: null,
    productionSaveError: null,
    selectedPanelCount: 0,
    stringingPanelIndexMode: 'all',
    stringingSelectedPanelIndexMap: null,
    systemSizeKw: null,
    mpptCountTotal: null,
    useTargetProduction: false,
    targetProductionKwh: 0,
    wiring: {
      ohm_per_m_string: 0.004,
      loop_factor: 2
    },
    wiringConfigured: false,
    maxDcAcRatio: 1.5,
    includeHourlyProduction: false,
    onlySelectedPanels: false,
    primaryInverterAutoQuantity: true,
    packageAdditionalInverters: [],
    weatherDatasetSelected: 'nsrdb_goes_v4_2024',
    weatherDatasetFetchedPath: null,
    isCreatingProposal: false,
    droneModal: {
      show: false,
      loading: false,
      src: '',
      project: null
    },
    pitch_in_degrees: true,
    shadingHasRun: false,
    shadingNeedsRerun: false,
    shadingRerunNoticeShown: false
  };
}

export function createInitialDesignHistoryState() {
  return {
    current: -1,
    state: ''
  };
}
